import React, { memo } from 'react';
import './heroBannerBlock.scss';
import { Link } from 'react-router-dom';
import ScrollButton from '../../common/ScrollButton';
import * as tools from '../../../utils/tools';
import ScrollToButton from '../../common/scrollToButton/scrollToButton';
import DownloadButton from '../../common/DownloadButton';

const heroBannerBlock = ({
  bannerData,
  downloadBtn,
  downloadUrl,
  btnTitle,
  scrollBtn,
  scrollTo,
  buttonTitle,
  scrollToSectionForContact,
  ...props
}) => {
  const bannerUrl = bannerData?.url;
  const bannerText = bannerData?.text;

  return (
    <>
      <section className='banner-section mb-0 hero-banner videoBanner'>
        <div
          style={{ backgroundImage: `url(${bannerUrl})` }}
          className='banner-img'
        >
          <div
            className='banner-img-mobile'
            style={{ backgroundImage: `url(${bannerUrl})` }}
          />

          <Link to='/' className='banner-logo'>
            <img src='/media/images/InClassica_White.svg' alt='logo' />
          </Link>
          <div className='banner-container'>
            <div
              className='banner-context hero-context white left'
              dangerouslySetInnerHTML={{ __html: bannerText }}
            />
          </div>
        </div>

        {downloadBtn && downloadUrl !== '' && (
          <DownloadButton
            btnTitle={btnTitle}
            downloadUrl={downloadUrl}
            white={props.downloadBtnWhite}
          />
        )}

        {scrollBtn && <ScrollButton scrollTo={scrollTo} title={buttonTitle} />}
        {scrollToSectionForContact && (
          <ScrollToButton
            duration={1500}
            elementId={scrollToSectionForContact.elementId}
            offset={
              tools.canUseDOM && document.getElementById('headLine')
                ? -document.getElementById('headLine').offsetHeight
                : ''
            }
          />
        )}
      </section>
    </>
  );
};

export default memo(heroBannerBlock);
